<template>
    <transition name="slide-down-fade">
        <div
            class="options-selector-container"
            :class="{ 'options-selector-container--invalid': isInvalid }"
            v-show="hasOptions"
            v-if="!defaultOptionSelected"
            @click="$emit('click')"
        >
            <div v-if="disabled" class="box"></div>
            <select
                class="options-selector"
                :class="{ 'options-selector--invalid': isInvalid }"
                :name="name"
                :id="id"
                :disabled="disabled"
                @change="optionChanged"
            >
                <option :selected="emptyOptionSelected" value="">{{
                    validationMessage || defaultValue
                }}</option>
                <option
                    v-for="option in options"
                    :value="option.product_option_value_id"
                    :key="option.product_option_value_id"
                    :selected="selectedValue === option.product_option_value_id"
                >
                    {{ option.product_option_value_title }}
                    <transition name="fade">
                        <slot name="option-sidetitle" :option="option" />
                    </transition>
                </option>
            </select>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        defaultValue: String,
        options: Array,
        id: String,
        name: String,
        selectedValue: String,
        disabled: Boolean,
        isPristine: Boolean,
    },
    computed: {
        hasOptions() {
            return this.options && this.options.length > 0;
        },
        isInvalid() {
            return (
                !this.isPristine && this.emptyOptionSelected && this.hasOptions
            );
        },
        validationMessage() {
            return this.isInvalid && "Select a valid option";
        },
        emptyOptionSelected() {
            return !this.selectedValue || this.selectedValue === "";
        },
        optionSelected() {
            return this.options.find(
                (option) => option.product_option_value_id == this.selectedValue
            );
        },
        defaultOptionSelected() {
            return (
                this.optionSelected && this.optionSelected.is_default_value == 1
            );
        },
    },
    methods: {
        optionChanged(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
$invalidColor: #f2c0de;
$defaultColor: #95989a;

.options-selector-container {
    position: relative;
    flex: 1;
    margin: 0 2%;
    .options-selector {
        border-radius: 22px;
        padding: 0px 39px 0 24px;
        border: 1px solid #efefef;
        height: 45px;
        appearance: none;
        background-color: white;
        color: $defaultColor;
        font-family: "Lato";
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 19px;
        &--invalid {
            color: $invalidColor;
            border-color: $invalidColor;
        }
    }
    &::after {
        content: "";
        position: absolute;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 9px solid $defaultColor;
        right: 24px;
        top: calc(50% - 4px);
    }
    &--invalid {
        &::after {
            border-top-color: $invalidColor;
        }
    }

    .box {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
}

.slide-down-fade-enter-active,
.slide-down-fade-leave-active {
    transition: opacity 0.4s, transform 0.3s;
}
.slide-down-fade-enter,
.slide-down-fade-leave-to {
    opacity: 0;
    transform: translateY(100%);
}
</style>
